export const layerToFormState = (layer?: PlateLayer): PlateLayerFormState | undefined => {
  if (!layer) return

  return {
    producer: layer.plate.producer,
    plateType: String(layer.plate.material.kind),
    plateMaterial: layer.plate.material.identifier,
    fastenerProducer: layer.fastener.producer,
    layer: {
      ...layer,
    },
  }
}

export const formStateToLayer = (formState: PlateLayerFormState): Layer => {
  const { layer } = formState

  return layer
}
